import Model from '../Model'

export default class Product extends Model {
  resource () {
    return 'products'
  }

  primaryKey () {
    return 'slug'
  }
}
